// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag_wrapper__rirUz"};